const create = (api) => {
  const getBatteriesToReplaceNowCard = (
    startDate = undefined,
    endDate = undefined,
    siteId = undefined,
    countAbove = 500,
    agingMonthsTop = 30,
    bottomBatteryPercentage = 50,
  ) => {
    return api.get(`/dashboard/batteryhealth/dashboardcombinedcount/${siteId}?startDate=${startDate}&endDate=${endDate}&cycleCountTop=${countAbove}&agingMonthsTop=${agingMonthsTop}&bottomBatteryPercentage=${bottomBatteryPercentage}`)
  }

  const getBatteriesToReplaceNowDetails = (
    startDate = undefined,
    endDate = undefined,
    siteId = undefined,
    params  = {},
    pageNumber = 1,
    pageSize = 100,
    countAbove = 500,
    agingMonthsTop = 30,
    bottomBatteryPercentage = 50,
  ) => {
    const query = (params.searchTerm === null || params.searchTerm === undefined) ? `&query=` : `&query=${params.searchTerm}`
    const sort = (params.sort === null || params.sort === undefined) ? `&sort=` : `&sort=${params.sort}`
    const directionSort = (params.directionSort === null || params.directionSort === undefined) ? `&directionSort=` : `&directionSort=${params.directionSort}`
    const language = (params.language === null || params.language === undefined) ? `&language=en-US` : `&language=${params.language}`
    const includeChildren = true
    return api.get(`/dashboard/batteryhealth/combined/details/${siteId}?startDate=${startDate}&endDate=${endDate}&cycleCountTop=${countAbove}&agingMonthsTop=${agingMonthsTop}&bottomBatteryPercentage=${bottomBatteryPercentage}&includeChildren=${includeChildren}&pageNumber=${pageNumber}&pageSize=${pageSize}` + `${query}` + `${sort}${directionSort}${language}`)
  }

 const getExportBatteriesToReplaceNowCVSFile = (
   siteId = undefined,
   startDate = undefined,
   endDate = undefined,
   params = {},
   pageNumber = 1,
   pageSize = 100,
   payload = null,
   countAbove = 500,
   agingMonthsTop = 30,
   bottomBatteryPercentage = 50,
  ) =>
   {
    const query = (params.query === null || params.query === undefined) ? `&query=` : `&query=${params.query}`
    const sort = (params.sort === null || params.sort === undefined) ? `&sort=` : `&sort=${params.sort}`
    const directionSort = (params.directionSort === null || params.directionSort === undefined) ? `&directionSort=` : `&directionSort=${params.directionSort}`
    const language = (params.language === null || params.language === undefined) ? `&language=en-US` : `&language=${params.language}`
    const includeChildren = true
    const chartName = params?.chartName || 'BATTERIES_REPLACE_SOON'
   return api.post(`/dashboard/exportfiles/${siteId}?startDate=${startDate}&endDate=${endDate}&chartName=${chartName}&cycleCountTop=${countAbove}&agingMonthsTop=${agingMonthsTop}&minimumBatteryPercentage=${bottomBatteryPercentage}&includeChildren=${includeChildren}&pageNumber=${pageNumber}&pageSize=${pageSize}&exportWithPagingSorting=true` + `${query}` + `${sort}${directionSort}${language}`, payload);
   }

  return {
    getBatteriesToReplaceNowCard,
    getBatteriesToReplaceNowDetails,
    getExportBatteriesToReplaceNowCVSFile
  }
}

export default {
  create
}
